import { useState } from 'react';

import { motion } from 'framer-motion';

import { LEGEND_REFERENCE_TYPES, REFERENCE_TYPE_STYLES } from './reference-styles';

export function ReferenceKey() {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="absolute top-2 right-0 z-10 flex cursor-default overflow-hidden rounded-lg bg-gray-50 p-1.5 text-xs"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {LEGEND_REFERENCE_TYPES.map((type, i) => {
        const style = REFERENCE_TYPE_STYLES[type];
        // Stack later items behind earlier ones so the leftmost (Facts) sits on top.
        const z = (LEGEND_REFERENCE_TYPES.length - i) * 10;
        return (
          <motion.div
            key={type}
            className={`flex items-center ${style.legendText}`}
            style={{ zIndex: z }}
            animate={{ marginLeft: hovered ? 12 : i === 0 ? 0 : -12 }}
            transition={{ type: 'spring', stiffness: 800, damping: 80 }}
          >
            <div className={`size-3.75 rounded border ${style.legendBox}`} />
            <motion.span
              className="-mb-px ml-1.5 whitespace-nowrap"
              animate={{ opacity: hovered ? 1 : 0, width: hovered ? 'auto' : 0 }}
              transition={{ duration: 0.15 }}
            >
              {style.label}
            </motion.span>
          </motion.div>
        );
      })}
    </div>
  );
}
